








































































































































































































import {
  Component, Vue,
} from 'vue-property-decorator';

import CustomTooltip from '@/vue-app/components/custom/CustomTooltip.vue';

import EditRetirementFundNewFundViewModel
  from '@/vue-app/view-models/components/goals-dashboard/edit-plan-goals/edit-retirement-fund-goal-plan/edit-retirement-fund-new-fund-view-model';

@Component({
  name: 'EditRetirementFundNewFund',
  components: { CustomTooltip },
})
export default class EditRetirementFundNewFund extends Vue {
  view_model = Vue.observable(
    new EditRetirementFundNewFundViewModel(this),
  );

  async mounted() {
    await this.view_model.initialize();
  }
}
